import {IBaseSchema} from '../../base.schema';
import {ISelectItem} from '../../drop-down';
import {IActivitySurvey} from '../activitySurvey';
import {ICenterSelect} from '../center';
import {IEntitySelect, IEntitySelectTable} from '../entity';
import {IParticipant} from '../participant';
import {IUser} from '../user';
import {IAction} from './action.interface';
import {IActivityData} from './activity-data.interface';
import {IPayment, IPmpPayment, PmpPaymentType} from './payment.interface';

export interface IDisposition extends ISelectItem {
    closed?: boolean;
    description?: string;
    errorMessage?: string;
}

export interface IActivitySubType extends ISelectItem {
    defaultDisposition?: IDisposition;
    dispositions?: IDisposition[];
    paymentIn?: ISelectItem[];
    paymentOut?: ISelectItem[];
}

export interface IActivityType extends ISelectItem {
    icon: string;
    subTypes: IActivitySubType[];
}

export interface IReferral {
    type: ISelectItem;
    date: Date;
    name?: string;
    medium?: ISelectItem;
    entity?: IEntitySelect;
}

export interface IActivityEntity {
    referral?: IReferral;
    reporting?: IEntitySelectTable[];
    agencies?: IEntitySelectTable[];
    referredTo?: IReferral;
}

export enum NoteStatus {
    Draft = 'Draft',
    Archived = 'Archived',
    Completed = 'Completed',
}

export interface INote extends IBaseSchema {
    _id?: string;
    // date: Date;
    note?: string;
    status: NoteStatus;
    author?: string;
    action: ISelectItem;
}

export interface IDocument extends IBaseSchema {
    _id?: string;
    confidential: boolean;
    action?: ISelectItem;
    // AWS uploaded key
    key: string;
    // date?: Date;
    // contenet type
    contentType: string;
    // file name
    name: string;
}

export interface IActivity extends IBaseSchema {
    /**
     * title of the activity
     */
    title?: string;

    type: IActivityType;

    subType: IActivitySubType;

    disposition?: IDisposition;
    dispositionComment?: string;

    openDate?: Date;
    openingComment?: string;

    closeDate?: Date;
    closeComment?: string;

    dollarReturnedParties?: string;
    nonDollarValueToParties?: string;
    nonDollerItems?: string;

    numberOfParticipants?: number;

    /**
     * Auto generated number to help track the  "conflict resolution" activities
     */
    automaticCaseNumber?: string;

    center: ICenterSelect;

    entity?: IActivityEntity;

    users?: IUser[];

    participants?: IParticipant[];

    surveys?: IActivitySurvey[];

    /**
     * Users who participated in activity, such as trainings
     */
    userParticipants?: IUser[];

    notes?: INote[];

    payments?: IPayment[];

    pmpPayments?: Partial<Record<PmpPaymentType, IPmpPayment[]>>;

    documents?: IDocument[];

    activityData?: IActivityData;

    actions?: IAction[];

    //** Check if the case is PMP */
    pmpCase?: boolean;
}

export type IActivityCreate = Omit<IActivity, '_id'>;

export type IActivitySelect = Pick<IActivity, '_id' | 'title'>;

export interface IActivityTable
    extends Pick<
        IActivity,
        | 'title'
        | 'active'
        | 'type'
        | 'subType'
        | 'disposition'
        | 'automaticCaseNumber'
        | 'closeDate'
        | 'participants'
        | 'userParticipants'
        | 'numberOfParticipants'
    > {
    _id: string;
}

export type IActivityAtivityData = Pick<IActivity, 'activityData' | 'pmpCase'>;
export type IActivityEntityData = Pick<IActivity, 'entity'>;

export interface IActivityCreated extends IActivity {
    _id: string;
}

export interface IPendingActionSearch {
    startDate: Date;
    endDate: Date;
}

// export const ACTIVITY_TYPES = [
//     {
//         id: ACTIVITY_TYPE_CONFLICT_RESOLUTION_ID,
//         type: 'Conflict Resolution',
//     },
//     {
//         id: ACTIVITY_TYPE_TRAINING_ID,
//         type: 'Training',
//     },
//     {
//         id: ACTIVITY_TYPE_OUTREACH_ID,
//         type: 'Outreach',
//     },
//     {
//         id: ACTIVITY_TYPE_VOLUNTEER_STAFF_MGMT_ID,
//         type: 'Volunteer/ Staff Management',
//     },
//     {
//         id: ACTIVITY_TYPE_ORG_EVENTS_ID,
//         type: 'Organizational Events',
//     },
//     {
//         id: ACTIVITY_TYPE_ORG_NETWORKING_ID,
//         type: 'Organizational Networking',
//     },
//     {
//         id: ACTIVITY_TYPE_ORG_DEV_ID,
//         type: 'Organizational Development',
//     },
//     {
//         id: ACTIVITY_TYPE_OTHER_ID,
//         type: 'Other',
//     },
// ];
